export enum UserRoles {
  CRM = 'CRM',
  MERCHANT = 'MERCHANT',
  PDA = 'PDA',
  EMPTY = '',
}
